<template>
    <el-col :xs="{span:24}" :md="settings.Width" class="el-form-item--large" :class="className" v-show="defaultShow">
        <el-tabs class="collapse-row" v-model="activeName" :class="width" ref="tabs" stretch>
            <template
                v-for="(tabitem, index) in settings.Childrens"
                :key="index">
                <el-tab-pane 
                    v-if="tabitem.Display"
                    :label="tabitem.Title"
                    :name="tabitem.Guid"
                    class="el-row">
                    <template #label>
                        <div v-show="tabitem.Display">
                            <i :class="tabitem.Prefix"></i> 
                            {{ tabitem.Title }}
                            <i :class="tabitem.Suffix"></i>
                        </div>
                    </template>
                    <component v-for="(field,index) in tabitem.Components"
                                :key="field.Name"
                                :is="field.FieldDefinition.Name"
                                :definition="field"
                                :data="data"
                                :htmlPrefix="htmlPrefix"
                                :contentType="contentType"
                                :formDefinition = "formDefinition"
                                :orginalDisplay = "orginalDisplay">
                    </component>
                </el-tab-pane>
            </template>
        </el-tabs>
    </el-col>
</template>

<script>
    import BaseLayout from "./LayoutBase";
    export default {
        name:"qweTabs",
        mixins: [BaseLayout],
        data: function () {
            return {
                width:"",
                activeName: "",
                gridWatcher: [],
                tabids: []
            };
        },
        created: function () {
            this.settings.Childrens.forEach(x => {
                x.Guid = QweGuid(10);
                x.OrginalTitle = x.Title;
                x.Display = true
            });

            let activeTab = this.settings.Childrens.find(x => x.OrginalTitle == this.settings.activeName);
            if(activeTab !=null && activeTab != undefined){
                this.activeName = activeTab.Guid;
            }
            else{
                this.activeName = this.settings.Childrens[0].Guid;
            }

            let SingleJieGuo = this.settings.Childrens.filter(x => x.Components.length === 1).filter(x => x.Components[0].FieldDefinition.Name === "LinkQueryField" || x.Components[0].FieldDefinition.Name === "SubFormField");
            let gridWatcher = SingleJieGuo.map(x => x.Components[0].Name);
            this.tabids = SingleJieGuo.map(x => x.Guid);
            gridWatcher.forEach((x, index) => {
                this.$watch(
                    'data.' + x + ".total", function (newVal, oldVal) {
                        if (newVal !== null) {
                            let guid = this.tabids[index];
                            let tabIndex = this.settings.Childrens.findIndex(y => y.Guid === guid);
                            if (tabIndex > -1) {
                                this.settings.Childrens[tabIndex].Title = this.settings.Childrens[tabIndex].OrginalTitle + "（" + newVal + "）";
                            }
                        }
                    }
                );
            });
        },

        watch:{
            "errorEventBus":function(){
                let errorComponentPath = this.errorComponentPath;
                let index = errorComponentPath.findIndex(x=> x.Field == this.name);
                if(index >-1){
                    let activeName = errorComponentPath[index].Active;
                    let activeTab = this.settings.Childrens.find(x => x.OrginalTitle == activeName);
                    if(activeTab !=null && activeTab != undefined){
                        this.activeName = activeTab.Guid;
                    }
                }
            }
        },
        
        methods: {
            initLayoutBase: function () {
                this.settings = this.definition.Settings;
            },

            handleTabClick: function(pane, ev){
                console.log(this.$refs.tabs)
                console.log(pane);
                console.log(ev);
            }
        }
    }
</script>